/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Clear_SpeakersInputs */



/**
* | output |
* | --- |
* | "Clear Speakers" |
*
* @param {Context_Menu_Clear_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_clear_speakers = /** @type {((inputs?: Context_Menu_Clear_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Clear_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer les locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Clear Speakers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altoparlanti chiari")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чистые динамики")
	if (locale === "es") return /** @type {LocalizedString} */ ("Altavoces claros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清晰的扬声器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリアなスピーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लियर स्पीकर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alto-falantes nítidos")
	return /** @type {LocalizedString} */ ("Clear Speakers")
});